import { Injectable }     from '@angular/core';
import {SergasDeviceService} from "./SergasDevice.service";

@Injectable()
export class SergasDeviceValuelistService {

  private valuelist: any = {};

  constructor(
    private service: SergasDeviceService
  ){
    this.reload();
  }

  reload() {
    return this.service.getPage(0,100000,"","").then(page => {
      this.valuelist = page.content.reduce((previous:any, current:any) => {
        previous[current.sergasDeviceId] = current;
        return previous;
      }, {})
    }).catch(error => error);
  }

  addValue(object: any) {
    this.valuelist[object.id] = object;
  }

  clear() {
    this.valuelist = {};
  }

  updateValue(id:any, data:any) {
    if ( this.valuelist[id] ) {
      (<any>Object).keys(data).forEach( (field:string) => {
        this.valuelist[id][field] = data[field];
      });
    }
  }

  deleteValue(id:any) {
    this.valuelist[id] = null;
    delete this.valuelist[id];
  }

  getValuelist(){
    return this.valuelist;
  }
}
